
$(function () {
    document.createElement("timezone");

    $("timezone").each(function () {
        $(this).text(elements_timezone_get_time_zone());
    });

    $(document).ajaxComplete(function () {
        $("timezone").each(function () {
            $(this).html(elements_timezone_get_time_zone());
        })
    })
});

function elements_timezone_get_time_zone() {
    var date = new Date().toString();
    var idx = date.indexOf("(");

    if (idx === -1) return "";
    else return date.substr(idx);
}